import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import callApi from "Common/utils/apiCaller";
import { use } from "i18next";

const SearchDropdown = ({
  input,
  handleBenchmarkChange,
  name,
  value,
  category,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchDefaultOptions = async () => {
      const response = await callApi("v1/indexversion/list", "post", {
        pageNum: 1,
        pageSize: 500,
        filters: {
          // return_type: input,
          is_populated: true,
        },
      });
      let options = response.data.indexversionList.map((item) => {
        return {
          label: `${item.index_code} - ${item?.index_id?.name}`,
          value: item.index_code,
          type: "index",
        };
      });
      setOptions(options);
    };

    fetchDefaultOptions();
  }, [input]);

  const fetchOptions = async (inputValue) => {
    if (!inputValue) return [];
    let filters: { [index: string]: any } = {};
    // filters.return_type = input;
    filters.qtext = inputValue;
    filters.is_populated = true;
    try {
      const response = await callApi("v1/indexversion/list", "post", {
        pageNum: 1,
        pageSize: 500,
        filters,
      });
      return response.data.indexversionList.flatMap((item) => {
        let options = [];
        if (item.index_code) {
          options.push({
            label: `${item.index_code} - ${item?.index_id?.name}`,
            value: item.index_code,
            type: "index",
          });
        }
        return options;
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const selected = value
    ? {
        label: options.find((opt) => opt.value === value)?.label || value,
        value,
      }
    : null;

  return (
    <AsyncSelect
      isClearable={true}
      cacheOptions
      loadOptions={fetchOptions}
      onChange={(e) => handleBenchmarkChange(name, e)}
      placeholder="Search..."
      value={selected}
      defaultOptions={options}
    />
  );
};

export default SearchDropdown;
